module.exports = __webpack_public_path__ + "img/cart-whiteline.429c8ba4.svg";